import { CartPage } from './cart.component';
import { connect } from 'react-redux';
import { updateCart, deleteCart } from "./../../api/cart/cartAction";

const mapDispatchToProps = {
    updateCart, deleteCart
};

const mapStateToProps = state => ({
    isLoading: state.cartPage.isLoading,
    cart: state.cartPage.cart
});

export const CartContainer = connect(mapStateToProps, mapDispatchToProps)(CartPage);